// extracted by mini-css-extract-plugin
module.exports = {"loading":"LoadingSign_loading__2zlKi","spinner":"LoadingSign_spinner__2mZvM","spin":"LoadingSign_spin__3EEcB"};